import api from '../api/axios';

export const serviceUsageService = {
  async getAll() {
    const response = await api.get('/service-usages?populate=*');
    return response.data.data;
  },

  async getByClient(clientId: number) {
    const response = await api.get(`/service-usages?filters[insuranceClient][id][$eq]=${clientId}&populate=*`);
    return response.data.data;
  },

  async getOne(id: number) {
    const response = await api.get(`/service-usages/${id}?populate=*`);
    return response.data.data;
  },

  async create(data: any) {
    const response = await api.post('/service-usages', { data });
    return response.data.data;
  },

  async update(id: number, data: any) {
    const response = await api.put(`/service-usages/${id}`, { data });
    return response.data.data;
  },

  async recordUsage(id: number, usageDate: string) {
    const usage = await this.getOne(id);
    const usageDates = usage.usageDates || [];
    
    const updateData = {
      usedCount: usage.usedCount + 1,
      lastUsedDate: usageDate,
      usageDates: [...usageDates, usageDate]
    };

    return this.update(id, updateData);
  },

  async delete(id: number) {
    const response = await api.delete(`/service-usages/${id}`);
    return response.data;
  }
};

